import { CollectionVariantDownload } from '../types/api/DownloadsTypes';
import { AnyAction } from 'redux';
import { GenericResponse } from '../types/api/Http';
import {
  ProductVariantDownloadResponse,
  ProductDownloadResponse
} from '../types/api/DownloadsTypes';
import { ApiError } from '../types/api/ErrorsTypes';

import { ERROR_CODES } from '../constants/api';
const { RATE_LIMIT_REACHED, DOWNLOAD_LIMIT_REACHED } = ERROR_CODES;
import { DOWNLOAD_STATUS_ACTIONS } from '../constants/actions';
const { DOWNLOAD_STATUS_UPDATE, SHOW_DOWNLOAD_LIMIT } =
  DOWNLOAD_STATUS_ACTIONS;

import { addMessage } from '../state/actions/messagesActions';
import { setVariantDownloadsLimitReached } from '../state/actions/rateLimitingStatusActions';

export const downloadsSortingFunction = (
  d1: CollectionVariantDownload,
  d2: CollectionVariantDownload
): number => {
  if (d1.resolution.toLowerCase().includes('k') || d2.resolution.toLowerCase().includes('k')) {
    const res1Num = parseInt(d1.resolution.toLowerCase().replace('k', '')) || 0;
    const res2Num = parseInt(d2.resolution.toLowerCase().replace('k', '')) || 0;

    if (res1Num !== res2Num) {
      return res1Num - res2Num;
    }

    const formatPriority: { [key: string]: number } = {
      jpg: 1,
      png: 2,
      mp4: 3,
      prores: 4,
      'prores 422 hq': 4,
      'prores 4444': 4,
      exr: 5,
      openexr: 5,
      'linear exr': 5,
      r3d: 6,
      mxf: 7
    };

    const format1Priority = formatPriority[d1.format.toLowerCase()] || 999;
    const format2Priority = formatPriority[d2.format.toLowerCase()] || 999;

    if (format1Priority !== format2Priority) {
      return format1Priority - format2Priority;
    }
  }

  if (d1.resolution.toLowerCase() < d2.resolution.toLowerCase()) return -1;
  if (d1.resolution.toLowerCase() > d2.resolution.toLowerCase()) return 1;

  if (d1.size < d2.size) return -1;
  if (d1.size > d2.size) return 1;

  return 0;
};

  const sortCollectionDownloadsFunction = (
    d1: CollectionVariantDownload,
    d2: CollectionVariantDownload
  ) => {
    // First sort by resolution for K values
    if (d1.resolution.toLowerCase().includes('k') || d2.resolution.toLowerCase().includes('k')) {
      const res1Num = parseInt(d1.resolution.toLowerCase().replace('k', '')) || 0;
      const res2Num = parseInt(d2.resolution.toLowerCase().replace('k', '')) || 0;

      if (res1Num !== res2Num) {
        return res1Num - res2Num;
      }
    }

    const format1 = d1.format.toLowerCase();
    const format2 = d2.format.toLowerCase();

    // Handle PRORES parts using format field
    if (format1.includes('prores') && format2.includes('prores')) {
      const partRegex = /part\s*(\d+)/i;
      const part1Match = format1.match(partRegex);
      const part2Match = format2.match(partRegex);

      if (part1Match && part2Match) {
        return parseInt(part1Match[1]) - parseInt(part2Match[1]);
      }
    }

    if (d1.size < d2.size) return -1;
    if (d1.size > d2.size) return 1;
    return 0;
  };


export const downloadResponseHandlerFunction = (
  response: GenericResponse<
    ProductVariantDownloadResponse | ProductDownloadResponse | ApiError | string | null
  >
): Array<AnyAction> => {
  let actionConfig: Array<AnyAction> = [];

  const downloads = (response?.data as ProductDownloadResponse)?.downloads_today;
  const downloadLimit = (response?.data as ProductDownloadResponse)?.download_limit;
  const hasDownloadLimit = !!downloadLimit || downloadLimit === 0;
  const downloads_today = (hasDownloadLimit && downloads > downloadLimit) ? downloadLimit : downloads;

  if (response.status === RATE_LIMIT_REACHED) {
    actionConfig.push(setVariantDownloadsLimitReached(true));
    return actionConfig;
  }

  if (response?.status === DOWNLOAD_LIMIT_REACHED) {
    actionConfig.push({
      type: DOWNLOAD_STATUS_UPDATE,
      data: { downloads: downloads_today, showDownloadLimitNotification: true, downloadLimit: downloadLimit }
    });
    actionConfig.push({ type: SHOW_DOWNLOAD_LIMIT });
    return actionConfig;
  }

  if (response?.status !== 200) {
    actionConfig.push(
      addMessage({
        type: 'error',
        body: 'Something went wrong, this download cannot be started. Try again later or reach out to support if the issue persists.'
      })
    );
    return actionConfig;
  }

  if (downloads) {
    actionConfig.push({
      type: DOWNLOAD_STATUS_UPDATE,
      data: { downloads: downloads_today, showDownloadLimitNotification: hasDownloadLimit, downloadLimit: downloadLimit }
    });
    if (hasDownloadLimit && downloads > downloadLimit) {
      actionConfig.push({ type: SHOW_DOWNLOAD_LIMIT });
    }
  }
  return actionConfig;
};

const downloadsHelpers = {
  downloadResponseHandlerFunction,
  downloadsSortingFunction,
  sortCollectionDownloadsFunction
};

export default downloadsHelpers;
